import { Button, VStack } from '@chakra-ui/react';
import styled from '../../../../consts/styled';

import NavigationSecondRow from '../../components/NavigationSecondRow';
import { colors, media, spacing } from '../../../../App/ChakraTheme';
import { LessonName as LessonNameUnStyled } from '../../../../components/LessonName';
import { LinkProps } from 'react-router-dom';

export const BackButton = styled(Button)`
  position: absolute;
  transform: translateY(-50%);
  left: ${spacing.BASE_PLUS};
  top: 50%;
  display: flex;
  align-items: center;
  color: ${colors.darkblue};
  svg {
    margin-right: ${spacing.TINY};
    transition: transform 400ms;
    transform: translateX(0);
  }
  &:hover {
    svg {
      transform: translateX(-10px);
    }
  }
  ${media.tablet`
    svg {
      height: 32px !important;
      width: 32px !important;
    }
    span{display:none;}
  `};
` as any as typeof Button & LinkProps;


export const LessonName = styled(LessonNameUnStyled)`
  cursor: pointer;
  margin-top: ${spacing.TINY};
  margin-bottom: ${spacing.TINY};
  align-items: flex-start !important;
  & > .body-x-small {
    transition: all 400ms;
    margin-left: 30px;
  }

  & > div.circle {
    width: 14px;
    height: 14px;
    margin-top: 6px;
    flex-shrink: 0;
    background-color: ${colors.white};
    border-color: ${(props) =>
      props.active
        ? colors.darkblue
        : colors.applyOpacity(colors.mischka, 0.8)};
  }
`;

export const LeftColumn = styled(VStack)<{ opened: boolean }>`
  padding-top: ${spacing.BASE_PLUS};
  width: 310px !important;
  flex-basis: 310px !important;
  flex-shrink: 0;
  flex-grow: 0;
  transition: margin-left 400ms, width 400ms;
  overflow-x: hidden;
  scroll-behavior: smooth;
  position: relative;
  margin-left: ${({ opened }) => (opened ? '0%' : '-310px')} !important;
  ${media.tablet`
    width: 280px !important;
    flex-basis: 280px !important;
    margin-left: ${({ opened }: any) => (opened ? '0' : '-280px')} !important;
  `};
`;

export const RightColumn = styled(VStack)`
  min-width: calc(100% - 120px);
  flex: 0 1 70% !important;
  overflow: auto;
  min-width: auto;
  flex-grow: 1 !important;
  ${media.tablet`
    margin-top:30px;
  `};
  ${media.phone`
    min-width: 100%;
  `};
`;

export const Rule = styled.div`
  height: 0px;
  width: 100%;
  border-top: 1px solid ${colors.applyOpacity(colors.mischka, 0.5)};
  margin-top: ${spacing.LARGE};
  margin-bottom: ${spacing.LARGE};
  ${media.phone`
    margin-top: ${spacing.BASE};
    margin-bottom: ${spacing.BASE};
  `}

  &.vertical {
    height: 100%;
    width: 0px;
    border-left: 1px solid ${colors.applyOpacity(colors.mischka, 0.5)};
    margin-left: ${spacing.LARGE};
    margin-right: ${spacing.LARGE};
    ${media.phone`
      margin-left: ${spacing.BASE};
      margin-right: ${spacing.BASE};
    `}
    margin-top: unset;
    margin-bottom: unset;
  }
`;

export const StyledRule = styled(Rule)<{ sideBarOpened: boolean }>`
  height: unset !important;
  margin-left: ${({ sideBarOpened }) =>
    sideBarOpened ? '0' : '58px'} !important;
  opacity: ${({ sideBarOpened }) => (sideBarOpened ? 0 : 1)};

  transition: margin-left 400ms;
  ${media.phone`
    display:none;
  `};
`;

export const ToggleSideBar = styled.div<{ opened: boolean }>`
  cursor: pointer;
  display: inline-block;
  text-align: right;
  position: absolute;
  padding-right: 10px;
  top: 0;
  transition: left 400ms;
  background-color: ${colors.white};
  left: ${({ opened }) => (opened ? '280px' : '0')};
  z-index: 5;
  ${media.tablet`
    left: ${({ opened }: any) => (opened ? '260px' : '0')};
  `}
`;

export const ProgramTitle = styled(NavigationSecondRow)`
  padding-left: 170px;
  ${media.tablet`
    padding-left: 60px;
  `}
`;
